module.exports = __webpack_public_path__ + "img/huawei-harmonyos.89dceee1.png";